import React from 'react';
import { createPortal } from 'react-dom';
import useBackButtonClose from '../utils/useBackButtonClose';

// "전체 보기" modal — shows every customer photo as a responsive grid.
// Clicking a photo fires onPick(index): the consumer jumps its carousel to
// that index and closes the modal (decision ① in the task spec).
//
// Props:
//   open: boolean
//   onClose: () => void
//   images: [{src, alt}]
//   title: header text
//   onPick: (index) => void

export default function PhotoGridModal({ open, onClose, images, title, onPick }) {
  // 모바일 뒤로가기로 모달만 닫기(SPA 이탈 방지). early-return 조건과 동일하게 판정.
  useBackButtonClose(open && !!images && images.length > 0, onClose);

  if (!open || !images || images.length === 0) return null;

  return createPortal(
    <div style={overlayStyle} onClick={onClose}>
      <div style={cardStyle} onClick={e => e.stopPropagation()}>
        <div style={headerStyle}>
          <h2 style={{ margin: 0, fontSize: '1.15rem', color: 'var(--text)' }}>
            {title || '전체 보기'}
          </h2>
          <button type="button" onClick={onClose} aria-label="닫기" style={closeBtnStyle}>
            ×
          </button>
        </div>

        <div style={gridStyle}>
          {images.map((img, i) => (
            <button
              key={`${img.src}-${i}`}
              type="button"
              onClick={() => { onPick && onPick(i); onClose(); }}
              aria-label={`${i + 1}번 사진 보기`}
              style={gridItemStyle}
            >
              <img
                src={img.src}
                alt={img.alt || ''}
                loading="lazy"
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
              />
            </button>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
}

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 200, padding: '84px 16px 20px',
};

const cardStyle = {
  background: 'var(--surface)',
  borderRadius: 12,
  border: '1px solid var(--border)',
  padding: 20,
  maxWidth: 960, width: '100%',
  maxHeight: '85vh', overflowY: 'auto',
};

const headerStyle = {
  display: 'flex', justifyContent: 'space-between',
  alignItems: 'center', marginBottom: 14,
};

const closeBtnStyle = {
  background: 'none', border: 'none',
  fontSize: '1.6rem', lineHeight: 1,
  color: 'var(--text-muted)', cursor: 'pointer', padding: 4,
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
  gap: 10,
};

const gridItemStyle = {
  display: 'block', width: '100%', aspectRatio: '4 / 3',
  padding: 0, border: 'none', borderRadius: 8, overflow: 'hidden',
  background: 'var(--surface-elev)', cursor: 'pointer',
};
